import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { Slot as w } from "@radix-ui/react-slot";
import { cva as N } from "class-variance-authority";
import * as _ from "react";
import { cn as u } from "../../utils.js";
import { CircularProgress as l } from "../CircularProgress/index.js";
const c = [
  "primary",
  "success",
  "warning",
  "critical",
  "black"
], o = {
  filled: {
    primary: "bg-primary-500",
    success: "bg-success-500",
    warning: "bg-warning-500",
    critical: "bg-critical-500",
    black: "bg-black"
  },
  text: {
    primary: "text-primary",
    success: "text-success",
    warning: "text-warning",
    critical: "text-critical",
    black: "text-black"
  },
  outlined: {
    primary: "border-primary-500 text-primary",
    success: "border-success-500 text-success",
    warning: "border-warning-500 text-warning",
    critical: "border-critical-500 text-critical",
    black: "border-black text-black"
  }
}, S = N(
  "inline-flex items-center justify-center rounded-md text-button  hover:bg-[linear-gradient(rgb(0_0_0/10%)_0_0)] ring-interactive-400 transition-colors focus:ring-2 focus:ring-offset-2 active:bg-[linear-gradient(rgb(0_0_0/20%)_0_0)] disabled:cursor-not-allowed disabled:text-onSurface-400 disabled:pointer-events-none relative overflow-hidden",
  {
    variants: {
      variant: {
        filled: "text-white",
        outlined: "border-2",
        text: ""
      },
      color: {
        null: "",
        ...c.reduce((e, n) => ({ ...e, [n]: "" }), {})
      },
      size: {
        xs: "px-1 py-0.5",
        sm: "px-1.5 py-1",
        md: "px-3 py-1.5",
        lg: "px-3.5 py-2",
        icon: "size-5"
      },
      rounded: {
        true: "rounded-full"
      }
    },
    defaultVariants: {
      variant: "filled",
      color: "primary",
      size: "md"
    },
    compoundVariants: [
      ...c.map((e) => ({
        variant: "filled",
        color: e,
        className: [o.filled[e], "disabled:bg-onSurface-200"]
      })),
      ...c.map((e) => ({
        variant: "outlined",
        color: e,
        className: [
          // Hover/Active states are common for all outlined buttons
          "hover:bg-onSurface-100 active:bg-onSurface-200 hover:bg-none active:bg-none",
          o.outlined[e],
          "disabled:bg-onSurface-200 disabled:border-onSurface-300 "
        ]
      })),
      ...c.map((e) => ({
        variant: "text",
        color: e,
        className: [
          // Hover/Active states are common for all text buttons
          "hover:bg-onSurface-100 active:bg-onSurface-200 hover:bg-none active:bg-none",
          o.text[e]
        ]
      }))
    ]
  }
), k = _.forwardRef(
  ({
    className: e = "",
    color: n,
    children: d,
    variant: b,
    size: a,
    loading: t = !1,
    rounded: m = !1,
    disabled: f = !1,
    asChild: p = !1,
    startAdornment: i,
    endAdornment: s,
    label: g,
    ...x
  }, v) => {
    const y = p ? w : "button";
    return b === "text" && !a && (a = "xs"), /* @__PURE__ */ h(
      y,
      {
        type: "button",
        className: u(
          S({ rounded: m, color: n, variant: b, size: a, className: e }),
          { "pointer-events-none": t },
          a === "xs" || a === "sm" ? "[&_svg]:size-2" : "[&_svg]:size-2.5"
        ),
        ref: v,
        disabled: f,
        ...x,
        children: [
          i && /* @__PURE__ */ r("span", { className: "me-1", children: t ? /* @__PURE__ */ r(l, { className: "text-inherit" }) : i }),
          /* @__PURE__ */ r(
            "span",
            {
              className: u(
                t && !i && !s ? "invisible" : "visible"
              ),
              children: d || g
            }
          ),
          s && /* @__PURE__ */ r("span", { className: "ms-1", children: t ? /* @__PURE__ */ r(l, { className: "text-inherit" }) : s }),
          t && !i && !s && /* @__PURE__ */ r(l, { className: "text-inherit absolute" })
        ]
      }
    );
  }
);
k.displayName = "Button";
export {
  k as Button
};
